export default {
  // ========== Filters and Selectors ==========
  programType: 'Type of {entity}',
  selectProgramType: 'Select Type of {entity}',
  selectProgramToFilter: 'Select {entity} to filter {sections}',
  selectA: 'Select a {entity}',
  level: 'Level',
  selectLevel: 'Select a Level',
  filterBy: 'Filter by {entity}',
  statusFilter: 'Status',
  statusAll: 'All',
  statusActive: 'Active',
  statusInactive: 'Inactive',
  lockedWhileFormOpen: 'Cannot be changed while a {entity} form is open for adding or editing.',

  // ========== Navigation ==========
  navigation: 'Navigation:',

  // ========== Action Buttons ==========
  viewSectionDetails: 'View {entity} details',
  sectionNotes: 'Notes of the {entity}',
  assessmentByStudent: 'Assessment by Student',
  sectionEvaluations: '{evaluations} of the {entity}',
  assessmentReport: 'Assessment Report',
  evaluationsProgression: 'Progression of {entity}',
  toggleSectionStatus: '{action} the Notes and Evaluations of the {entity}',

  // ========== Messages ==========
  noSearchResults: 'No results found for',
  excelRequiresFilters: 'Select an Egress Profile and a Period in the filters above to download the Excel.',
  mustSelectProgram: 'You must select {entity} before Adding {section}',
  matterLockedAfterCreation: 'The {subject} cannot be changed once the {section} is created, since its evaluations are generated at creation.',
  egressProfileWithoutCampuses: 'This {profile} has no {campuses} assigned, so the {section} cannot be created.',
  goToEgressProfile: 'Go to the {profile} to add them',
  goToMatrix2: 'Go to the {matrix} to add them',
  egressProfileWithoutSubjects: 'This {profile} has no {subject} registered, so the {section} cannot be created.',
  mustAddSubject: 'You must add at least one {subject} in {program} to create {section}',
  confirmDelete: 'Are you sure you want to delete this instance of {entity}?',
  deleteWarning: 'This action cannot be reversed and the referenced objects at the bottom will be deleted.',
  sectionDeleted: '{entity} deleted.',
  sectionStatus: '{entity} {status}',
  active: 'Active',
  closed: 'Closed',

  // ========== Form Steps ==========
  step1Details: 'Step 1: Details of the {entity}',
  step2AssignStudents: 'Step 2: Assign Student(s)',
  step3AssignTeachers: 'Step 3: Assign Teacher(s)',
  detailsOf: 'Details of the {entity}',
  assignStudents: 'Assign Student(s)',
  assignTeachers: 'Assign Teacher(s)',

  // ========== Selectors ==========
  selectEntity: 'Select a {entity}',
  selectEntityWithDashes: '-- Select a {entity} --',

  // ========== Validations ==========
  sectionAlreadyExists: 'A section with those characteristics and name already exists.',
  cannotCreateSectionEvaluationErrors: 'The {section} cannot be created because there are evaluations with errors in the {subject}.',
  forMoreInfo: 'for more information press',
  seeMore: 'see more',

  // ========== Modals ==========
  incompleteInfo: 'Incomplete Information',

  // ========== Users ==========
  students: 'Students',
  teachers: 'Teachers',
  noStudentsAssigned: 'No students assigned to the {entity}',
  studentsList: 'Students',
  loading: 'Loading...',

  // ========== Step Navigation ==========
  previousStep: 'Previous step',
  nextStep: 'Next step',

  // ========== Confirmations ==========
  confirmDeleteSection: 'Are you sure you want to delete the Section?',

  // ========== Status Messages ==========
  creating: 'Creating {entity}...',
  pleaseWaitWhileCreating: 'Please wait while it is being created.',
  entityCreated: '{entity} created.',
  entityModified: '{entity} modified.',
  entityDeleted: '{entity} deleted.',

  // ========== Email Search Modal ==========
  emailQuickSearchTitle: 'Quick search by email',
  emailSearchInstruction: 'Enter emails separated by comma (,) for quick search.',
  emailSearchMaxLimit: 'Maximum {count} emails per search.',
  emailSearchPlaceholder: 'example@email.com, next@email.com, another@email.com',
  emailsAlreadyAssigned: 'Emails already assigned ({count}):',
  emailsFound: 'Emails found ({count}):',
  usersWithWrongRole: 'Users found but with incorrect role ({count}):',
  emailsNotFound: 'Emails not found ({count}):',
  selectFoundEmails: 'Select found',
  newSearch: 'New search',
  addNewUser: 'Add new user',
  usersAssigned: 'Users assigned',
  confirmCloseSearch: 'Are you sure?',
  confirmCloseSearchText: 'You have search results. Do you want to close without selecting the found users?',
  yesClose: 'Yes, close',
  roleRequired: 'Role required: {roles}',
  roleNotSpecified: 'role not specified',
  selected: 'Selected',
}
